// these are frontend input list keys not data, since we have translation feature they must be the same as translation keys
export const GlobalData = {
    currency: {
        "USD": "$",
        "EUR": "€",
        "GBP": "£",
        "JPY": "¥",
        "AUD": "A$",
        "CAD": "C$",
        "TND": "TND",
        "CHF": "CHF",
        "CNY": "¥",
        "HKD": "HK$",
        "NZD": "NZ$",
        "SGD": "S$",
        "SEK": "kr",
        "NOK": "kr",
        "DKK": "kr",
        "INR": "₹",
        "ZAR": "R",
        "MXN": "$",
        "BRL": "R$",
        "KRW": "₩",
        "RUB": "₽",
        "PLN": "zł",
        "TRY": "₺",
        "THB": "฿",
        "IDR": "Rp",
        "SAR": "﷼",
        "AED": "د.إ",
        "ILS": "₪",
        "MYR": "RM",
        "PHP": "₱",
        "AFN": "؋",
        "ALL": "L",
        "AMD": "֏",
        "ANG": "ƒ",
        "AOA": "Kz",
        "ARS": "$",
        "AWG": "Afl",
        "AZN": "₼",
        "BAM": "KM",
        "BBD": "Bds$",
        "BDT": "৳",
        "BGN": "лв",
        "BIF": "FBu",
        "BMD": "BMD$",
        "BND": "B$",
        "BOB": "Bs.",
        "BWP": "P",
        "BYN": "Br",
        "BZD": "BZ$",
        "CDF": "FC",
        "DJF": "Fdj",
        "DOP": "RD$",
        "DZD": "دج",
        "EGP": "£",
        "ERN": "Nfk",
        "ETB": "Br",
        "FJD": "$",
        "FKP": "£",
        "GEL": "₾",
        "GHS": "GH₵",
        "GIP": "£",
        "GMD": "D",
        "GNF": "FG",
        "GTQ": "Q",
        "GYD": "$",
        "HNL": "L",
        "HRK": "kn",
        "HTG": "G",
        "HUF": "Ft",
        "IQD": "ع.د",
        "IRR": "﷼",
        "ISK": "kr",
        "JMD": "J$",
        "JOD": "د.ا",
        "KES": "KSh",
        "KGS": "с",
        "KHR": "៛",
        "KMF": "CF",
        "KWD": "د.ك",
        "KYD": "$",
        "KZT": "₸",
        "LAK": "₭",
        "LBP": "ل.ل",
        "LKR": "Rs",
        "LRD": "$",
        "LSL": "M",
        "MAD": "د.م.",
        "MDL": "L",
        "MGA": "Ar",
        "MKD": "ден",
        "MMK": "K",
        "MNT": "₮",
        "MOP": "P",
        "MUR": "Rs",
        "MVR": "Rf",
        "MWK": "MK",
        "MZN": "MT",
        "NAD": "$",
        "NGN": "₦",
        "NIO": "C$",
        "NOK": "kr",
        "NPR": "Rs",
        "PAB": "B/.",
        "PEN": "S/",
        "PGK": "K",
        "PKR": "₨",
        "PLN": "zł",
        "PYG": "₲",
        "QAR": "ر.ق",
        "RON": "lei",
        "RSD": "дин",
        "RWF": "FRw",
        "SBD": "$",
        "SCR": "SRe",
        "SHP": "£",
        "SLE": "Le",
        "SOS": "Sh",
        "SRD": "$",
        "STD": "Db",
        "SZL": "L",
        "TJS": "SM",
        "TOP": "T$",
        "TTD": "$",
        "TWD": "NT$",
        "TZS": "Sh",
        "UAH": "₴",
        "UGX": "Sh",
        "UYU": "$",
        "UZS": "soʻm",
        "VEF": "Bs.F.",
        "VND": "₫",
        "VUV": "VT",
        "WST": "T",
        "XAF": "XOF",
        "XCD": "$",
        "XOF": "CFA",
        "YER": "ر.ي",
        "ZMW": "ZK"
    },
    currencyName: {
        "USD": "US Dollar",
        "EUR": "Euro",
        "GBP": "British Pound",
        "JPY": "Japanese Yen",
        "AUD": "Australian Dollar",
        "CAD": "Canadian Dollar",
        "TND": "Tunisian Dinar",
        "CHF": "Swiss Franc",
        "CNY": "Chinese Yuan",
        "HKD": "Hong Kong Dollar",
        "NZD": "New Zealand Dollar",
        "SGD": "Singapore Dollar",
        "SEK": "Swedish Krona",
        "NOK": "Norwegian Krone",
        "DKK": "Danish Krone",
        "INR": "Indian Rupee",
        "ZAR": "South African Rand",
        "MXN": "Mexican Peso",
        "BRL": "Brazilian Real",
        "KRW": "South Korean Won",
        "RUB": "Russian Ruble",
        "PLN": "Polish Zloty",
        "TRY": "Turkish Lira",
        "THB": "Thai Baht",
        "IDR": "Indonesian Rupiah",
        "SAR": "Saudi Riyal",
        "AED": "United Arab Emirates Dirham",
        "ILS": "Israeli New Shekel",
        "MYR": "Malaysian Ringgit",
        "PHP": "Philippine Peso",
        "AFN": "Afghan Afghani",
        "ALL": "Albanian Lek",
        "AMD": "Armenian Dram",
        "ANG": "Netherlands Antillean Guilder",
        "AOA": "Angolan Kwanza",
        "ARS": "Argentine Peso",
        "AWG": "Aruban Florin",
        "AZN": "Azerbaijani Manat",
        "BAM": "Bosnia and Herzegovina Convertible Mark",
        "BBD": "Barbadian Dollar",
        "BDT": "Bangladeshi Taka",
        "BGN": "Bulgarian Lev",
        "BIF": "Burundian Franc",
        "BMD": "Bermudian Dollar",
        "BND": "Brunei Dollar",
        "BOB": "Bolivian Boliviano",
        "BWP": "Botswana Pula",
        "BYN": "Belarusian Ruble",
        "BZD": "Belize Dollar",
        "CDF": "Congolese Franc",
        "DJF": "Djiboutian Franc",
        "DOP": "Dominican Peso",
        "DZD": "Algerian Dinar",
        "EGP": "Egyptian Pound",
        "ERN": "Eritrean Nakfa",
        "ETB": "Ethiopian Birr",
        "FJD": "Fijian Dollar",
        "FKP": "Falkland Islands Pound",
        "GEL": "Georgian Lari",
        "GHS": "Ghanaian Cedi",
        "GIP": "Gibraltar Pound",
        "GMD": "Gambian Dalasi",
        "GNF": "Guinean Franc",
        "GTQ": "Guatemalan Quetzal",
        "GYD": "Guyanaese Dollar",
        "HNL": "Honduran Lempira",
        "HRK": "Croatian Kuna",
        "HTG": "Haitian Gourde",
        "HUF": "Hungarian Forint",
        "IQD": "Iraqi Dinar",
        "IRR": "Iranian Rial",
        "ISK": "Icelandic Krona",
        "JMD": "Jamaican Dollar",
        "JOD": "Jordanian Dinar",
        "KES": "Kenyan Shilling",
        "KGS": "Kyrgyzstani Som",
        "KHR": "Cambodian Riel",
        "KMF": "Comorian Franc",
        "KWD": "Kuwaiti Dinar",
        "KYD": "Cayman Islands Dollar",
        "KZT": "Kazakhstani Tenge",
        "LAK": "Laotian Kip",
        "LBP": "Lebanese Pound",
        "LKR": "Sri Lankan Rupee",
        "LRD": "Liberian Dollar",
        "LSL": "Lesotho Loti",
        "MAD": "Moroccan Dirham",
        "MDL": "Moldovan Leu",
        "MGA": "Malagasy Ariary",
        "MKD": "Macedonian Denar",
        "MMK": "Burmese Kyat",
        "MNT": "Mongolian Tugrik",
        "MOP": "Macanese Pataca",
        "MUR": "Mauritian Rupee",
        "MVR": "Maldivian Rufiyaa",
        "MWK": "Malawian Kwacha",
        "MZN": "Mozambican Metical",
        "NAD": "Namibian Dollar",
        "NGN": "Nigerian Naira",
        "NIO": "Nicaraguan Córdoba",
        "NPR": "Nepalese Rupee",
        "PAB": "Panamanian Balboa",
        "PEN": "Peruvian Nuevo Sol",
        "PGK": "Papua New Guinean Kina",
        "PKR": "Pakistani Rupee",
        "PYG": "Paraguayan Guarani",
        "QAR": "Qatari Rial",
        "RON": "Romanian Leu",
        "RSD": "Serbian Dinar",
        "RWF": "Rwandan Franc",
        "SBD": "Solomon Islands Dollar",
        "SCR": "Seychellois Rupee",
        "SHP": "Saint Helena Pound",
        "SLE": "Sierra Leonean Leone",
        "SOS": "Somali Shilling",
        "SRD": "Surinamese Dollar",
        "STD": "São Tomé and Príncipe Dobra",
        "SZL": "Swazi Lilangeni",
        "TJS": "Tajikistani Somoni",
        "TOP": "Tongan Paʻanga",
        "TTD": "Trinidad and Tobago Dollar",
        "TWD": "New Taiwan Dollar",
        "TZS": "Tanzanian Shilling",
        "UAH": "Ukrainian Hryvnia",
        "UGX": "Ugandan Shilling",
        "UYU": "Uruguayan Peso",
        "UZS": "Uzbekistani Som",
        "VEF": "Venezuelan Bolívar",
        "VND": "Vietnamese Dong",
        "VUV": "Vanuatu Vatu",
        "WST": "Samoan Tala",
        "XAF": "Central African CFA Franc",
        "XCD": "East Caribbean Dollar",
        "XOF": "West African CFA Franc",
        "YER": "Yemeni Rial",
        "ZMW": "Zambian Kwacha"
    },
    product: {
        typologies: [
            "MielDeFleurs",
            "MielDeForêt",
            "MielDAcacia",
            "MielDeManuka",
            "MielDeLavande",
            "MielDeThym",
            "MielDeChâtaignier",
            "MielDeMélisse",
            "MielPolyfloral",
            "MielMonofloral",
            "autre"
        ],
        captures: [
            "extractionAFroid",
            "ExtractionChauffée",
            "ExtractionCentrifuge",
            "ÉcrasementEtFiltration",
            "ExtractionParPression",
            "ExtractionSousVide",
            "ExtractionParGravité",
            "DécapageEtDrainage",
            "ExtractionEnMorceaux",
            "ExtractionUltrasonique",
            "autre"
        ],
        conservations: [
            "conserverEntre10Et25C",
            "réfrigération",
            "placezLesProduitsÀLabriDeLaLumière",
            "séparerLesProduitsSelonLesVariétés",
            "utilisezDesEmballagesHermétiques",
            "maintenezLHumiditéAppropriée",
            "autre"
        ],
        transformations: [
            "enÉtatBrut",
            "filtré",
            "pasteurisé",
            "crystallisé",
            "mélangé",
            "crémeux",
            "autre"
        ],
        congelations: [
            "congelé", // Frozen
            "congeléÀTempératureContrôlée", // Controlled temperature freezing
            "congélationRapide", // Quick freezing
            "congeléEnVrac", // Bulk freezing
            "autre" // other
        ],
        certifications: [
            "certificationBio", // Organic Certification
            "certificationCommerceEquitable", // Fair Trade Certification
            "certificationAssuranceQualité", // Quality Assurance Certification
            "certificationHACCP", // HACCP Certification
            "certificationGLOBALGAP", // GLOBAL.GAP Certification
            "certificationISO", // ISO Certification
            "certificationIGP", // PGI (Protected Geographical Indication)
            "certificationAOP", // PDO (Protected Designation of Origin)
            "certificationSTG", // TSG (Traditional Specialty Guaranteed)
            "certificationSansOGM" // Non-GMO Certification
        ],
        emballages: [
            "bocalEnVerre", // Glass Jar
            "bocalEnPlastique", // Plastic Jar
            "boiteEnMetal", // Metal Tin
            "bouteilleEnPlastique", // Plastic Bottle
            "mielEnRayon", // Comb Honey
            "conteneurEnVrac", // Bulk Container
            "bouteilleEnVerre", // Glass Bottle
            "sachetEnPlastique", // Plastic Pouch
            "boiteEnBois", // Wooden Box
            "boiteEnConserve",
            "autre"
        ],
    },
    user: {
        services: [
            "generalManagement",
            "salesManagement",
            "technicalManagement",
            "exportManagement",
            "logisticsDirector",
            "customPackaging",
            "marketingAndPromotions",
            "qualityAssurance",
            "consultancy",
            "training",
            "other"
        ],
        functions: [
            "director",
            "salesperson",
            "engineer",
            "technician",
            "beekeeper",
            "secretary",
            "itSpecialist",
            "consultant",
            "trainer",
            "other"
        ],
        activities: [
            "beekeepers",
            "distributors",
            "hives",
            "materialsandEquipment",
            "sanitaryProducts",
            "queensAndBeeSwarms",
            "packaging",
            "softwareandTech",
            "logisticsandHandling",
            "bankingandInsurance",
            "publishingand Press",
            "associations",
            "other"
        ],
        activities_imgs: [
            "apiculteur.jpg",
            "distrubition.jpg",
            "ruche.jpg",
            "materiel.png",
            "produit.jpeg",
            "reine.jpg",
            "emballage.jpg",
            "info.jpg",
            "ca4.png",
            "assurance.jpg",
            "presseetedition.jpg",
            "association.jpeg"
        ],
        civilities: [
            "mr",
            "mrs",
            "dr",
            "prof"
        ],
        legalStructures: [
            "SARL",
            "SA",
            "SAS",
            "SNC",
            "SC",
            "EURL",
            "Auto-entrepreneur",
            "other"
        ],
        daysOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
        ]



    },

    ads: {
        categories: [
            "Matériel",
            "Extraction",
            "Transhumance",
            "Maturation",
            "Désoperculation",
            "Fonte de cire",
            "Mise en pot",
            "Produits d'élevage",
            "Reine vierge",
            "Reine fécondée",
            "Paquet d’abeilles",
            "Cellule royale",
            "Essaim sur cadres",
            "Ruche et ses accessoires",
            "Ruche et ses éléments",
            "Ruchette de fécondation",
            "Trappe à pollen",
            "Nourrisseur",
            "Produits de la ruche",
            "Miel",
            "Gelée royale",
            "Pollen",
            "Cire",
            "Propolis",
            "Formation/ Emploi",
            "Offre d’emploi/ de stage",
            "Stage initiation",
            "Stage perfectionnement",
            "Livre",
            "Plante mellifère",
            "Graines",
            "Arbuste",
            "Arbre",
            "Autre"
        ]
    },



    salesOrders: {
        statusDelivery: [
            "En Cours",
            "Livrée",
            "En attente de transfert",
            "Annulée"
        ]
    },




}